// app-components/investor-profile/co-investment-network/NetworkCTA.jsx
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';

const NetworkCTA = ({ hiddenCount }) => {
    const { t, i18n } = useTranslation();

    return (
        <div className="min-w-0 border border-gray-200 rounded-lg overflow-hidden">
            {/* Image and Content Layout */}
            <div className="flex flex-col">
                {/* Top - Image */}
                <div className="w-full h-48">
                    <div
                        className="w-full h-full rounded-t-lg bg-cover bg-center"
                        style={{
                            backgroundImage:
                                "url('https://crino-cdn.nyc3.cdn.digitaloceanspaces.com/CTA_images/investor_profile_co_network.webp')",
                        }}
                    />
                </div>

                {/* Bottom - Content */}
                <div className="p-6 bg-gradient-to-br from-blue-50 to-purple-50">
                    <div className="flex flex-wrap items-center justify-center gap-2 mb-3 text-center">
                        <Lock className="h-6 w-6 shrink-0 text-blue-600" />
                        <h5 className="min-w-0 text-xl font-bold leading-tight text-gray-900 break-words">
                            {t('pageInvProf.unlockMorePartners') || 'Unlock More Partners'}
                        </h5>
                    </div>

                    

                    <p className="text-center text-sm leading-relaxed text-gray-600 mb-4 break-words">
                        {t('pageInvProf.upgradeToSeeAll') || 
                            'Upgrade to Startup or Professional membership to see all co-investment partners and detailed collaboration history.'}
                    </p>

                    <div className="flex flex-col gap-2">
                        <Link
                            to={`${i18n.language === 'en' ? '' : `/${i18n.language}`}/pricing`}
                            className="inline-flex min-h-9 items-center justify-center rounded-md px-4 py-2 text-center text-sm font-medium leading-tight transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring bg-stone-900 text-white shadow hover:bg-stone-900/90 w-full break-words"
                        >
                            {t('pageInvProf.viewPricing') || 'View Pricing'}
                        </Link>

                        <div className="text-center text-xs leading-snug text-gray-500 break-words">
                            {t('pageInvProf.startupPlanFrom') || 'Startup plan from'} <span className="font-semibold">$19/mo</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NetworkCTA;
